export type StationTotalPlaysParameters = {
  webStationId: string;
};

export type StationTotalPlaysResponse = {
  stationId: number;
  kind: 'totalPlays';
  data: {
    rows: number[];
  };
  columnHeader: {
    name: 'Plays';
    type: 'integer';
  }[];
};

export const fetchStationTotalPlays = async ({
  webStationId,
}: StationTotalPlaysParameters): Promise<StationTotalPlaysResponse> => {
  try {
    const resp = await fetch(
      `/api/proxy/v3/analytics/station/webStationId:${webStationId}/totalPlays`,
      {
        credentials: 'same-origin',
      }
    );
    if (resp.ok) {
      return resp.json();
    }

    throw new Error('Unable to get station total plays');
  } catch (err) {
    throw new Error(err.message);
  }
};
